<template>
  <div class="d-flex justify-content-between" v-if="header.contractName">
    <div>
      <div class="d-flex">
        <h4>
          <span v-if="isRequest">بيانات الطلب ل{{ header.requestTypeName }} {{ header.contractName }} رقم {{
            header.requestCode }}</span>
          <span v-else>وثيقة عقد {{ header.contractName }} رقم {{ header.contractCode }}</span>
        </h4>
        <p class="mx-3" :class="itemStatusClass">
          <i class="fas fa-circle mx-2 fa-xs"></i>
          {{ isRequest ? header.requestStatusName : header.contractStatusName }}
        </p>
      </div>
      <div class="d-flex">
        <div class="d-flex" v-if="isRequest">
          <p><b>تاريخ إنشاء الطلب</b></p>
          <p class="mx-4">{{ header.contractCreatedDate | formatGregToHijri }} هـ</p>
        </div>
        <div class="d-flex" v-else>
            <p><b>تاريخ بداية العقد</b></p>
            <p class="mx-4">{{ header.contractStartDate | formatGregToHijri }} هـ</p>
            <p><b>تاريخ نهاية العقد</b></p>
            <p class="mx-4" v-if="header.contractEndDate">{{ header.contractEndDate | formatGregToHijri }} هـ</p>
            <p class="mx-4" v-else> <center> --- </center>    </p>

        </div>
        <p><b>جهة الإصدار</b></p>
        <p class="mx-4">خدمات العقود الإلكترونية </p>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center" v-if="isRequest && header.remainingHours > 0">
      <div class="px-5">
        <p class="m-0 p-0">الوقت المتبقي </p>
        <p class="m-0 p-0"> لاعتماد العقد</p>
      </div>
      <v-progress-circular dir="ltr" class="primary-color" :rotate="-90" :size="100" :width="6"
        :value="header.remainingHoursPercent">
        <h5 class="mb-0 font-weight-bold dark-color"> {{ header.remainingHours }} </h5>
        <p class="mb-0 dark-color"> ساعة</p>
      </v-progress-circular>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { HeaderModel } from '@/models/headerModel';
import { Utils } from '@/utils/utils';

@Component
export default class ContractHeaderComponent extends Vue {
  @Prop({ required: true }) header!: HeaderModel;

  /** Used to distinguish whether the loaded data is a request or a contract. */
  isRequest = false;

  itemStatusClass = '';

  mounted() {
    if (!this.header) return;

    this.isRequest = this.$route.name === 'requestDetails';
    this.itemStatusClass = this.isRequest ? Utils.getRequestStatusCssClass(this.header.requestStatusId) : Utils.getContractStatusCssClass(this.header.contractStatusId);
  }
}
</script>
